import { createNextTableContext } from '@shared/modules/next-table/context/context';

export const CurrenciesTableContext = createNextTableContext();
export const CashRegistersTableContext = createNextTableContext();
export const CashRegisterOperationsTableContext = createNextTableContext();
export const CashFlowTransactionsTableContext = createNextTableContext();
